import {
    Box,
    Button,
    Container,
    Grid,
    Typography,
    CircularProgress,
} from "@material-ui/core";
import { CreateLogRequestInput } from "generated-interfaces/graphql";
import { TextField } from "mui-rff";
import React, { useEffect, useState } from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import dayjs from "dayjs";
import {
    createLogRequest,
    fetchLogRequest,
    LOG_REQUEST_ACTIONS,
} from "redux/reducers/logRequestReducer";
import {
    getSelectedLogRequestLoadingSelector,
    getSelectedLogRequestSelector,
} from "redux/selectors/logRequestSelector";
import { SelectedLogRequest } from "./SelectedLogRequest";
import { useRecursiveTimeout } from "hooks/useRecursiveTimeout";
import { LOG_REQUEST_IN_PROGRESS_STATUSES } from "utils/constants";

export const LogRequestPage = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { logRequestId } = useParams<{ logRequestId: string }>();
    const selectedLogRequest = useSelector(getSelectedLogRequestSelector);
    const selectedLogRequestLoading = useSelector(
        getSelectedLogRequestLoadingSelector
    );

    const [form, setForm] = useState<CreateLogRequestInput>({
        restaurantCode: "",
        macAddress: "",
        timeStartAt: dayjs()
            .startOf("hour")
            .subtract(1, "day")
            .format("YYYY-MM-DD"),
    });

    const submit = (data: CreateLogRequestInput) => {
        if (logRequestId) {
            return;
        }
        if (!data.macAddress || !data.restaurantCode || !data.timeStartAt) {
            alert("All fields are mandatory");
            return;
        }
        dispatch(
            createLogRequest({
                macAddress: data.macAddress,
                restaurantCode: data.restaurantCode,
                timeStartAt: dayjs(data.timeStartAt).format("YYYY-MM-DDTHH:mm"),
            })
        );
    };

    useRecursiveTimeout((): Promise<any> => {
        if (
            logRequestId &&
            selectedLogRequest &&
            LOG_REQUEST_IN_PROGRESS_STATUSES.includes(selectedLogRequest.status)
        ) {
            return Promise.resolve(
                dispatch(fetchLogRequest(Number(logRequestId)))
            );
        }
        return Promise.resolve(true);
    }, 10000);

    useEffect(() => {
        console.log("logRequestId", logRequestId);
        if (logRequestId) {
            dispatch(fetchLogRequest(Number(logRequestId)));
        } else {
            dispatch(LOG_REQUEST_ACTIONS.resetSelectedLogRequest());
            setForm({
                restaurantCode: "",
                macAddress: "",
                timeStartAt: dayjs()
                    .startOf("hour")
                    .subtract(1, "day")
                    .format("YYYY-MM-DD"),
            });
        }
    }, [logRequestId, dispatch]);

    useEffect(() => {
        console.log("selectedLogRequest", selectedLogRequest);
        if (logRequestId && selectedLogRequest) {
            setForm({
                restaurantCode: selectedLogRequest.restaurantCode,
                macAddress: selectedLogRequest.macAddress,
                timeStartAt: dayjs(
                    Number(selectedLogRequest.timeStartAt)
                ).format("YYYY-MM-DD"),
            });
        }
    }, [logRequestId, selectedLogRequest]);

    return (
        <Container>
            <Typography variant="h3">Search Logs</Typography>
            <Grid item xs={12}>
                <Form
                    initialValues={form}
                    onSubmit={submit}
                    render={({ handleSubmit, values }) => (
                        <form onSubmit={handleSubmit} noValidate>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={4}>
                                    <TextField
                                        label="Restaurant Code"
                                        name="restaurantCode"
                                        required
                                        disabled={!!logRequestId}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        label="Mac Address"
                                        name="macAddress"
                                        required
                                        disabled={!!logRequestId}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        name="timeStartAt"
                                        label="Log start date"
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        required
                                        disabled={!!logRequestId}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                spacing={2}
                                alignItems="center"
                                style={{ paddingTop: "10px" }}
                            >
                                {!!logRequestId ? (
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            type="button"
                                            onClick={() => {
                                                history.push("/log");
                                            }}
                                        >
                                            New Request
                                        </Button>
                                    </Grid>
                                ) : (
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                        >
                                            Submit
                                        </Button>
                                    </Grid>
                                )}
                                {!!selectedLogRequest &&
                                    selectedLogRequest.inputFilePath && (
                                        <Grid item>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                type="button"
                                                href={
                                                    selectedLogRequest.inputFilePath
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Download device log file
                                            </Button>
                                        </Grid>
                                    )}
                                {!!selectedLogRequest &&
                                    selectedLogRequest.outputFilePath && (
                                        <Grid item>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                type="button"
                                                href={
                                                    selectedLogRequest.outputFilePath
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Download parsed log file
                                            </Button>
                                        </Grid>
                                    )}
                            </Grid>
                        </form>
                    )}
                />
            </Grid>

            <Box paddingTop={5}>
                {!selectedLogRequest && selectedLogRequestLoading && (
                    <CircularProgress />
                )}

                {!!logRequestId && !!selectedLogRequest && (
                    <SelectedLogRequest logRequest={selectedLogRequest} />
                )}
            </Box>
        </Container>
    );
};
